import { apiEndpoints } from 'shared/model/apiEndpoints'

import {
  BonusHistoryHeaderResponse,
  BonusLevelResponse,
  ClientGeneralInfoRequest,
  ClientGeneralInfoResponse,
  ClientHeaderInfoResponse,
  ClientParams,
  EditBonusRequest,
  EditBonusResponse,
  OrderHistoryHeaderResponse,
} from 'modules/Clients/types'

import { globalAPI } from 'shared/config/redux/api/global'
import {
  BONUS_HISTORY_HEADER,
  GET_CLIENT,
  GET_HEADER_CLIENT,
  GET_TABLE_DATA,
} from 'shared/config/redux/constants/tags'

export const clientsApi = globalAPI.injectEndpoints({
  endpoints: (build) => ({
    getLoyalStatus: build.query<BonusLevelResponse, void>({
      query: () => ({
        url: apiEndpoints.bonusLevel,
      }),
    }),
    getClientHeaderInfo: build.query<
      ClientHeaderInfoResponse,
      { params: ClientParams }
    >({
      query: ({ params }) => ({
        url: `${apiEndpoints.clients}${params.clientId}${apiEndpoints.clientHeaderInfo}`,
      }),
      providesTags: [GET_HEADER_CLIENT],
    }),
    getClientGeneralInfo: build.query<
      ClientGeneralInfoResponse,
      { params: ClientParams }
    >({
      query: ({ params }) => ({
        url: `${apiEndpoints.clients}${params.clientId}/`,
      }),
      providesTags: [GET_CLIENT],
    }),
    changeGeneralInfo: build.mutation<
      ClientGeneralInfoResponse,
      ClientGeneralInfoRequest
    >({
      query: ({ clientId, ...body }) => ({
        url: `${apiEndpoints.clients}${clientId}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [GET_CLIENT, GET_HEADER_CLIENT, GET_TABLE_DATA],
    }),
    getOrderHistoryHeader: build.query<
      OrderHistoryHeaderResponse,
      { params: ClientParams }
    >({
      query: ({ params }) => ({
        url: `${apiEndpoints.clients}${params.clientId}/orders/headerInfo/`,
      }),
    }),
    getBonusHistoryHeader: build.query<
      BonusHistoryHeaderResponse,
      { params: ClientParams }
    >({
      query: ({ params }) => ({
        url: `${apiEndpoints.clients}${params.clientId}/bonusHistory/headerInfo/`,
      }),
      providesTags: [BONUS_HISTORY_HEADER],
    }),
    editBonusHistory: build.mutation<EditBonusResponse, EditBonusRequest>({
      query: (body) => ({
        url: apiEndpoints.editBonus,
        method: 'POST',
        body,
      }),
      invalidatesTags: [
        GET_TABLE_DATA,
        BONUS_HISTORY_HEADER,
        GET_HEADER_CLIENT,
      ],
    }),
  }),
})

export const {
  useGetLoyalStatusQuery,
  useGetClientGeneralInfoQuery,
  useGetClientHeaderInfoQuery,
  useChangeGeneralInfoMutation,
  useGetOrderHistoryHeaderQuery,
  useGetBonusHistoryHeaderQuery,
  useEditBonusHistoryMutation,
} = clientsApi
